export default (container = document) => {
    container.querySelectorAll('.messenger-link:not(.messenger-link--bound)').forEach(link => {
        link.classList.add('messenger-link--bound')

        link.addEventListener('click', event => {
            event.preventDefault()

            let data = {
                msg: link.dataset.msg,
                phone: link.dataset.phone,
                messenger: link.dataset.messenger
            }

            $.get('/page/index/license', data, ({ html }) => {
                swal.fire({
                    html,
                    showConfirmButton: false,
                    willOpen(popup) {
                        let messengerLink = popup.querySelector('.messenger-link')

                        messengerLink.addEventListener('click', event => {
                            if (messengerLink.classList.contains('tw-opacity-50')) {
                                event.preventDefault()
                            }
                        })

                        popup.querySelector('input[name="agree_personal_data"]').addEventListener('change', event => {
                            ['tw-cursor-not-allowed', 'tw-opacity-50'].forEach(c => {
                                messengerLink.classList.toggle(c, ! event.target.checked)
                            })
                        })
                    }
                })
            })
        })
    })
}